export function OnClickAnchor(props) {
  function onClick(event) {
    event.preventDefault();
    props.onClick();
  }

  return (
    <a href="# " onClick={onClick} className={props.className || ""}>
      {props.children}
    </a>
  );
}